// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BillCoverage\ApiBillCoverage.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Bill, BillData, BillOptions } from 'data/models/Bill';
import { DispatchEvent, DispatchEventData, DispatchEventOptions } from 'data/models/DispatchEvent';
import { JobOrder, JobOrderData, JobOrderOptions } from 'data/models/JobOrder';

// BillCoverageData is the class that BillCoverage serializes to/from
export interface BillCoverageData {
    Id : number;
	
    Bill : BillData | null;
    BillId : number;
    DispatchEvent : DispatchEventData | null;
    DispatchEventId : number;
    JobOrder : JobOrderData | null;
    JobOrderId : number;
	
    Type : string | null;
}

// BillCoverageOptions is the class which may be passed to the BillCoverage constructor to define optional initial data values
export interface BillCoverageOptions {
    Id : number;
	
    Bill? : BillOptions | null;
    BillId? : number;
    DispatchEvent? : DispatchEventOptions | null;
    DispatchEventId? : number;
    JobOrder? : JobOrderOptions | null;
    JobOrderId? : number;
	
    Type? : string | null;
}

export class BillCoverage {
    public Id : DataSignal<number>;
	
    public Bill : DataSignal<Bill | null>;
    public BillId : DataSignal<number>;
    public DispatchEvent : DataSignal<DispatchEvent | null>;
    public DispatchEventId : DataSignal<number>;
    public JobOrder : DataSignal<JobOrder | null>;
    public JobOrderId : DataSignal<number>;
	
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : BillCoverageOptions);
    constructor(data: BillCoverageOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Bill = S.value<Bill | null>(null);
        this.BillId = jsonableObservable(S.value<number>(data && data.BillId !== undefined ? data.BillId : 0));
        this.DispatchEvent = S.value<DispatchEvent | null>(null);
        this.DispatchEventId = jsonableObservable(S.value<number>(data && data.DispatchEventId !== undefined ? data.DispatchEventId : 0));
        this.JobOrder = S.value<JobOrder | null>(null);
        this.JobOrderId = jsonableObservable(S.value<number>(data && data.JobOrderId !== undefined ? data.JobOrderId : 0));
	    
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : BillCoverage) {
        return obj.Id();
    }
    
    static dataKey(obj : BillCoverageOptions) {
        return obj.Id;
    }

    static update(obj : BillCoverage, data : BillCoverageOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BillId !== undefined) obj.BillId(data.BillId);
            if (data.DispatchEventId !== undefined) obj.DispatchEventId(data.DispatchEventId);
            if (data.JobOrderId !== undefined) obj.JobOrderId(data.JobOrderId);
	        
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BillCoverage.ts